module.exports = __webpack_public_path__ + "img/qilin-f-stage2.74f97840.png";